import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { combineValues, globalTheme } from '@clds/component-theme';
import { focusVisible } from '@clds/style-utils';
import { typography } from '@clds/typography';
import { Layout } from '../constants';
import { solidTabOrientationVariant, tabsTheme } from '../TabsTheme';
const t = tabsTheme.solid.tab;
const foregroundColorMixin = (color) => css `
  color: ${color};
  svg path {
    fill: ${color};
  }
`;
const activeCss = (variant) => css `
  ${variant === 'solid' &&
    css `
    background-color: ${combineValues(t.background.color.active, (color) => rgba(color, 0.1))};
  `};
  ${foregroundColorMixin(t.font.color.active)};
`;
const disabledCss = css `
  background-color: ${t.background.color.disabled};
  ${foregroundColorMixin(t.font.color.disabled)};
  opacity: 0.5;
  pointer-events: none;
`;
const hoverCss = css `
  :hover {
    ${foregroundColorMixin(t.font.color.hover)};
  }
`;
const focusCss = css `
  outline: none;
  &${focusVisible()} {
    z-index: 10;
    box-shadow: inset 0 0 0 4px
        ${combineValues(t.focus.color, (color) => rgba(color, 0.5))},
      inset 0 0 0 1px ${t.focus.color};
  }
`;
export const TabChildrenWrapper = styled.span ``;
const fixedCss = css `
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${tabsTheme.solid.layout.fixed.padding};
  flex-basis: 0;
  height: 3.5rem;
  min-width: 64px;
  max-width: 160px;

  > :not(:first-child) {
    margin-left: 0;
  }

  ${TabChildrenWrapper} {
    width: 100%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${typography.xs.regular};
`;
export const TabContent = styled.div `
  ${({ variant }) => variant === 'solid'
    ? css `
          background-color: ${t.background.color.base};
          ${typography.sm.regular};
        `
    : css `
          ${typography.xs.regular};
        `};
  ${({ variant }) => css `
    padding: ${tabsTheme[variant].tab.verticalPadding}
      ${tabsTheme[variant].tab.horizontalPadding};
  `};

  ${foregroundColorMixin(t.font.color.base)};

  &,
  svg path {
    transition-duration: 250ms;
    transition-timing-function: linear;
    transition-property: background-color, color, fill, box-shadow, opacity;
  }

  cursor: ${({ disabled, onClick }) => (disabled || !onClick ? '' : 'pointer')};

  display: flex;
  flex: 1 0 auto;
  justify-content: ${solidTabOrientationVariant((variant) => variant.tabContent.alignItems)};

  scroll-snap-align: start;
  width: auto;

  > :not(:first-child) {
    margin-left: ${({ variant }) => tabsTheme[variant].tab.horizontalPadding};
  }

  ${({ layout }) => layout === Layout.FIXED && fixedCss};

  ${focusCss};

  ${({ disabled, active, variant }) => disabled ? disabledCss : active ? activeCss(variant) : hoverCss};

  svg {
    // backward compatibility with old icon package
    width: ${globalTheme.spacing.md};
    height: ${globalTheme.spacing.md};
  }
`;
//# sourceMappingURL=TabContent.js.map